import { gql } from '@apollo/client';

export const SET_AWAY_SHOTS = gql`
  mutation SetAwayShots($gameId: Int!, $awayShots: Int!) {
    update_schedule_by_pk(
      pk_columns: { id: $gameId }
      _set: { awayShots: $awayShots }
    ) {
      id
    }
  }
`;

export const SET_HOME_SHOTS = gql`
  mutation SetHomeShots($gameId: Int!, $homeShots: Int!) {
    update_schedule_by_pk(
      pk_columns: { id: $gameId }
      _set: { homeShots: $homeShots }
    ) {
      id
    }
  }
`;
